// extracted by mini-css-extract-plugin
export default {"tags_container":"truncated_tags_tags_container__trnVM"};